export function getAppTourUrl(serviceName: string): string | undefined {
  switch (serviceName.trim().toLowerCase()) {
    case 'listy':
    case 'リスティー':
      return '/tours/listy.html';
    case 'lbulk':
    case 'エルバルク':
      return '/tours/lbulk.html';
    default:
      return undefined;
  }
}
